const DISCIPLINES_CATEGORY_FILTER_FIELD = "learning_material_disciplines_normalized";
const CONSORTIUM_CATEGORY_FILTER_FIELD = "consortium.keyword";
const PUBLISHER_DATE_FIELD = "publisher_date";

export { DISCIPLINES_CATEGORY_FILTER_FIELD, CONSORTIUM_CATEGORY_FILTER_FIELD, PUBLISHER_DATE_FIELD };
